// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"248":"2be8ddaf","995":"91a1f710"}[chunkId] + ".chunk.js";
};